import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import SkeletonRect from 'creative-ui/uikit/skeleton/SkeletonRect';

import { Flex } from '@/components/Layout/Flex/Flex';

const OTP_DIGITS = [
  'digit-1',
  'digit-2',
  'digit-3',
  'digit-4',
  'digit-5',
  'digit-6',
];

function ChallengeMFASkeleton() {
  return (
    <BaseWrapper>
      {/* Title + description skeleton */}
      <Flex
        direction="column"
        align="center"
        gap={8}
        style={{ marginBottom: 24 }}>
        <SkeletonRect width={200} height={28} align="center" />
        <SkeletonRect width={280} height={16} align="center" />
      </Flex>

      {/* Form skeleton */}
      <Flex direction="column" gap={24}>
        {/* Phone input skeleton */}
        <Flex direction="column" gap={8}>
          <SkeletonRect width={100} height={14} />
          <SkeletonRect width="100%" height={48} />
        </Flex>

        {/* OTP input skeleton */}
        <Flex direction="column" gap={8}>
          <SkeletonRect width={80} height={14} />
          <Flex gap={8}>
            {OTP_DIGITS.map((id) => (
              <SkeletonRect key={id} width={48} height={48} />
            ))}
          </Flex>
        </Flex>

        {/* Button skeleton */}
        <SkeletonRect width="100%" height={48} />
      </Flex>
    </BaseWrapper>
  );
}

export default ChallengeMFASkeleton;
